import Stack from '@mui/material/Stack';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { blue } from '@material-ui/core/colors/';
import products from '../../data/computer'
import { useHistory } from "react-router-dom";
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[800],
  '&:hover': {
    backgroundColor: blue[900],
  },
}));

export default function BtnLicenseWithouHardware() {
  const history = useHistory();

  const routeChange = () =>{ 
    let path = '/expiring-license' 
    history.push(path);
  }
  return (
    <Stack spacing={2} direction="row">
      <ColorButton
        style={{  minWidth: '62%', minHeight: '3.5rem'  }}
        startIcon={<SettingsApplicationsIcon></SettingsApplicationsIcon>}
        onClick={routeChange}
        size="larger" variant="contained">Licenças sem hardwares: {3}
      </ColorButton>
    </Stack>
  );
}